module.exports = __webpack_public_path__ + "img/zgc.77761f8f.png";